export default ({ app }, inject) => {
    inject('validateContentRelationship', (relationship) => {
        return relationship && relationship.id && !relationship.isBroken;
    });
    return app;
};